import "./FoodPrice.css";
import { MdAccessTime } from "react-icons/md";

function FoodPrice({ food }) {
  return (
    <div className="food-price">

      <div className="food-price-left">

        <span className="offer-price">
          ₹{food.offerPrice || food.price}
        </span>

        {food.offerPrice && (
          <span className="actual-price">
            ₹{food.price}
          </span>
        )}

      </div>

      <div className="food-time">

        <MdAccessTime />

        <span>{food.preparationTime} mins</span>

      </div>

    </div>
  );
}

export default FoodPrice;